import type { JSX } from 'react';

export const RemoteMeetingIcon = (): JSX.Element => (
  <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M34.9141 42.7393H54.4793" stroke="#3C3C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M34.9141 47.9565H47.9575" stroke="#3C3C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M37.5234 32.3046C37.5234 29.1741 38.5669 26.0437 40.9147 23.9567C43.0017 21.6089 46.1321 20.5654 49.2626 20.5654C52.393 20.5654 55.5234 21.6089 57.6104 23.9567C59.9582 26.3046 61.0017 29.1741 61.0017 32.3046H37.5234Z"
      stroke="#3C3C46"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.2597 16.6522C53.6945 16.6522 57.0858 13.2609 57.0858 8.82609C57.0858 4.3913 53.6945 1 49.2597 1C44.8249 1 41.4336 4.3913 41.4336 8.82609C41.4336 13.2609 44.8249 16.6522 49.2597 16.6522Z"
      stroke="#3C3C46"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.0856 7.78244C55.7813 8.56505 54.216 8.82592 52.6508 8.82592C48.9986 8.82592 45.6073 6.73896 43.7812 3.34766"
      stroke="#3C3C46"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 60.9999C1 57.8694 2.04348 54.739 4.3913 52.652C6.47826 50.3042 9.6087 49.2607 12.7391 49.2607C15.8696 49.2607 19 50.3042 21.087 52.652C23.4348 54.9999 24.4783 57.8694 24.4783 60.9999H1Z"
      stroke="#3C3C46"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7401 45.348C17.1749 45.348 20.5662 41.9567 20.5662 37.5219C20.5662 33.0871 17.1749 29.6958 12.7401 29.6958C8.30537 29.6958 4.91406 33.0871 4.91406 37.5219C4.91406 41.9567 8.30537 45.348 12.7401 45.348Z"
      stroke="#3C3C46"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5661 36.4782C19.2617 37.2609 17.6965 37.5217 16.1313 37.5217C12.4791 37.5217 8.82694 35.4348 7.26172 32.0435"
      stroke="#3C3C46"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.304 37.522C30.7388 37.522 29.6953 38.5655 29.6953 40.1307V53.1741C29.6953 54.7394 30.7388 55.7828 32.304 55.7828H36.2171V61.0002L42.7388 55.7828H58.391C59.9562 55.7828 60.9997 54.7394 60.9997 53.1741V40.1307C60.9997 38.5655 59.9562 37.522 58.391 37.522H32.304Z"
      stroke="#3C3C46"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M25.784 6.21729H6.21875" stroke="#3C3C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19.2622 11.4346H6.21875" stroke="#3C3C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M29.6957 1C31.2609 1 32.3043 2.04348 32.3043 3.6087V16.6522C32.3043 18.2174 31.2609 19.2609 29.6957 19.2609H25.7826V25.7826L19.2609 19.2609H3.6087C2.04348 19.2609 1 18.2174 1 16.6522V3.6087C1 2.04348 2.04348 1 3.6087 1H29.6957Z"
      stroke="#3C3C46"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
